import React from 'react';
import { useAppShell } from '../../contexts/AppShellContext';
import KitchenLayout from '../Navigation/KitchenLayout';
import StarterRecipeHome from './StarterRecipeHome';

const RecipeGallery: React.FC = () => {
  const { skin } = useAppShell();
  const isYolo = skin === 'yolo';

  return (
    <KitchenLayout title="Gallery" className={isYolo ? 'bg-[#f7f3e8]' : 'bg-gray-50'}>
      <StarterRecipeHome isYolo={isYolo} />
    </KitchenLayout>
  );
};

export default RecipeGallery;
